import React from "react"

import ListWidgetHeader from "../../common/ListWidgetHeader"
import SearchBar from "../../common/SearchBar"
import CommunityListContainer from "./CommunityListContainer"

const CommunityListWidget = ({
    onFilterSelect,
    canAdd,
    addNewCommunity,
    nameSearch,
    isFetching,
    invalidate,
    pagingRequest,
    onSearch
}) => (
    <div className="widget">
        <ListWidgetHeader
            isFetching={isFetching}
            canAdd={canAdd}
            iconComponent={<span className="icon icon-community" />}
            listTitle="Communities"
            invalidate={invalidate(pagingRequest)}
            onAdd={addNewCommunity}
            onFilterSelect={onFilterSelect}
        />
        <div className="search-bar-container">
            <SearchBar searchTerm={nameSearch} onSearch={onSearch} />
        </div>
        <CommunityListContainer />
    </div>
)

export default CommunityListWidget
